import { useMutation } from "@tanstack/react-query";
import { axios } from "lib/axios";
import { queryClient } from "lib/react-query";
import { useCentralStore } from "stores";

export const updateDenominationChurch = ({
  churchData,
  denominationId,
  churchId
}) => {
  return axios.post(
    `/denominations/${denominationId}/denomination-churches/${churchId}?_method=PATCH`,
    churchData
  );
};

export const useUpdateDenominationChurch = ({ config } = {}) => {
  const setNotification = useCentralStore.getState().setNotification;

  return useMutation({
    onSuccess: () => {
      queryClient.invalidateQueries("denomination-churches");
      setNotification({
        type: "success",
        message: "Church updated successfully!"
      });
    },
    ...config,
    mutationFn: updateDenominationChurch
  });
};
